import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  fetchMetierTypes,
  createMetierTypeApi,
  updateMetierTypeApi,
  deleteMetierTypeApi,
  fetchMetiers,
  createMetierApi,
  updateMetierApi,
  deleteMetierApi,
  fetchProsMetiers,
} from "../services/metiersService";
import { resolveApiErrorMessage } from "../utils/resolveApiErrorMessage";

export const METIER_TYPES_QK = ["metierTypes"];
export const METIERS_QK = ["metiers"];
export const PROS_METIERS_QK = ["prosMetiers"];

// Queries
export const useMetierTypes = () =>
  useQuery({ queryKey: METIER_TYPES_QK, queryFn: fetchMetierTypes });

export const useMetiers = () =>
  useQuery({ queryKey: METIERS_QK, queryFn: fetchMetiers });

export const useProsMetiers = () =>
  useQuery({ queryKey: PROS_METIERS_QK, queryFn: fetchProsMetiers });

// Mutations: types
export const useCreateMetierType = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createMetierTypeApi,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: METIER_TYPES_QK });
      toast.success("Métier bien ajouté", { autoClose: 3000 });
    },
    onError: (err) =>
      toast.error(resolveApiErrorMessage(err, "Métier non ajouté"), {
        autoClose: 3000,
      }),
  });
};

export const useUpdateMetierType = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }) => updateMetierTypeApi(id, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: METIER_TYPES_QK });
      toast.success("Type de métier bien modifié", { autoClose: 3000 });
    },
    onError: (err) =>
      toast.error(resolveApiErrorMessage(err, "Type de métier non modifié"), {
        autoClose: 3000,
      }),
  });
};

export const useDeleteMetierType = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteMetierTypeApi,
    onSuccess: () => qc.invalidateQueries({ queryKey: METIER_TYPES_QK }),
  });
};

// Mutations: metiers
export const useCreateMetier = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createMetierApi,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: METIERS_QK });
      toast.success("Métier bien ajouté", { autoClose: 3000 });
    },
    onError: (err) =>
      toast.error(resolveApiErrorMessage(err, "Métier non ajouté"), {
        autoClose: 3000,
      }),
  });
};

export const useUpdateMetier = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }) => updateMetierApi(id, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: METIERS_QK });
      toast.success("Métier bien modifié", { autoClose: 3000 });
    },
    onError: (err) =>
      toast.error(resolveApiErrorMessage(err, "Métier non modifié"), {
        autoClose: 3000,
      }),
  });
};

export const useDeleteMetier = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteMetierApi,
    onSuccess: () => qc.invalidateQueries({ queryKey: METIERS_QK }),
  });
};
